import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import type { AnalyticsAndInsightsRouteFactory } from "./analyticsAndInsightsRouteContext";

const DashboardScreen = lazyRouteComponent(
  () => import("../DashboardScreen"),
  "DashboardScreen",
);

export const createDashboardRoutes: AnalyticsAndInsightsRouteFactory = ({
  context,
}) => [
  createRoute({
    getParentRoute: context.getParentRoute,
    path: `${context.basePath}/dashboard`,
    component: DashboardScreen,
  }),
];
